var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ContentPage_container"}},[_c('publicTop'),_vm._m(0),_c('div',{staticClass:"contentBox wapper",domProps:{"innerHTML":_vm._s(_vm.DemoText)}}),_c('publicBottom')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bgcBox"},[_c('p',{staticClass:"bgcBox_p1"},[_vm._v("技术支持")])])
}]

export { render, staticRenderFns }